<template>
  <div class="cancel-plan">
    <div v-if="!cancelationFormSubmit">
      <p>{{ labels.cancelDescription }}</p>
      <textarea rows="4" v-model="cancelationMessage"></textarea>
      <div class="text-right mt-4">
        <b-button @click="onSubmit" variant="primary">{{
          labels.cancelButton
        }}</b-button>
      </div>
    </div>
    <div v-if="cancelationFormSubmit" class="text-center pt-5 pb-5">
      <h3 class="text-septenary bold">{{ labels.thanks }}</h3>
      <h4 class="bold">{{ labels.weWillContactYou }}</h4>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      cancelationFormSubmit: false,
      cancelationMessage: '',
    }
  },
  computed: {
    ...mapGetters({ resources: 'resources' }),
    labels: function() {
      return this.resources.page.home.accountDetail
    },
  },

  methods: {
    onSubmit: function() {
      this.cancelationFormSubmit = true
      this.$root.$emit('track:cancelation', {
        data: { cancelMessage: this.cancelationMessage },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.cancel-plan {
  display: flex;
  flex-direction: column;

  textarea {
    border-radius: 32px;
    width: 100%;
    padding: 1rem;
  }
}
</style>
